import {AddSchema} from "mobx-graphlink";
import {TriggerSet} from "../@TriggerSet.js";
import {GetValues} from "js-vextensions";

export class EngineConfig_MemoryPalace {
	constructor(data?: Partial<EngineConfig_MemoryPalace>) {
		Object.assign(this, data);
	}

	enabled = true;

	nextPrompt_triggerSet: TriggerSet;
	prevPrompt_triggerSet: TriggerSet;
	voice_volumeMultiplier: number;
	prompt_chanceForMove: number;
	prompt_movePhrase: string;
	targetPool: string[];
	selectionType: PoolEntrySelectionType;
}
AddSchema("EngineConfig_MemoryPalace", {
	properties: {
		enabled: {type: "boolean"},

		nextPrompt_triggerSet: {$ref: "TriggerSet"},
		prevPrompt_triggerSet: {$ref: "TriggerSet"},
		voice_volumeMultiplier: {type: "number"},
		prompt_chanceForMove: {type: "number"},
		prompt_movePhrase: {type: "string"},
		targetPool: {type: "array", items: {type: "string"}},
		selectionType: {$ref: "PoolEntrySelectionType"}
	},
});

export enum PoolEntrySelectionType {
	"sequential" = "sequential",
	"random" = "random",
}
AddSchema("PoolEntrySelectionType", {enum: GetValues(PoolEntrySelectionType)});